import React, { useState, useRef, useEffect } from 'react';
import EmailPreview from './EmailModal';
import { FiMail, FiClock, FiAlertCircle, FiArchive, FiTrash2, FiArrowRightCircle } from "react-icons/fi";
import EmailComponent from './EmailModal';
import { FiAlertTriangle, FiFlag, FiCheckCircle } from "react-icons/fi";

const emails = [
  {
    sender: "DeepLearning.AI",
    snippet: "Please confirm your subscription status to DeepLearning.AI",
    time: "Jan 22",
    priority: "Normal",
    emailData: {
      from: 'Ashneet Kaur',
      fromemail: 'asheetkaur@gmail.com',
      to: 'Halo sr',
      subject: 'Application for Python Developer Intern Position',
      date: 'Dec 20, 2021',
      time: '5:47 PM',
      content: `
        Good Evening,
    
        I hope this email finds you well. My name is Ashneet Kaur, a B.Tech Computer Science and Engineering student, graduating in 2025. I am excited to apply for the Python Developer Intern position at your esteemed organization.
    
        With hands-on experience in Python and Flask, I have built dynamic backend systems, integrated RESTful APIs, and ensured seamless application functionality. My expertise in MongoDB for efficient data management, combined with deploying cloud-ready applications on AWS, has
        equipped me to deliver scalable solutions. Additionally, I have implemented secure authentication mechanisms and leveraged GitHub for version control in collaborative projects.
    
        Here's how my skills align with your requirements:
    
        * Backend Development: Proficient in Python and Flask for robust application development.
        * Database Management: Skilled in designing and optimizing MongoDB databases.
        * API Integration: Experienced in creating and connecting RESTful APIs effectively.
        * Cloud Deployment: Hands-on experience deploying scalable solutions on AWS.
        * Collaboration Tools: Adept at version control and team collaboration using GitHub.
    
        I am inspired by your organization's commitment to fostering innovation and excellence. Joining your team would not only allow me to contribute meaningfully but also enable me to grow as a developer in a dynamic environment.
    
        I have attached my resume for your review and would be delighted to discuss how my skills align with your team's goals. Thank you for considering my application. I look forward to the opportunity to contribute and learn from your expertise.
    
        Warm regards,
        Ashneet Kaur
        7668431481
      `,
      attachments: [{ name: 'Scanned by Gmail' }],
    }
  },
  {
    sender: "Nirmal Oqlous AI",
    snippet: "Invitation from an unknown sender: Oqlous AI X Darwinbox Exploration Call",
    time: "Jan 25",
    priority: "High",
    emailData: {
      from: 'Ashneet Kaur',
      fromemail: 'asheetkaur@gmail.com',
      to: 'Halo sr',
      subject: 'Application for Python Developer Intern Position',
      date: 'Dec 20, 2021',
      time: '5:47 PM',
      content: `
        Good Evening,
    
        I hope this email finds you well. My name is Ashneet Kaur, a B.Tech Computer Science and Engineering student, graduating in 2025. I am excited to apply for the Python Developer Intern position at your esteemed organization.
    
        With hands-on experience in Python and Flask, I have built dynamic backend systems, integrated RESTful APIs, and ensured seamless application functionality. My expertise in MongoDB for efficient data management, combined with deploying cloud-ready applications on AWS, has
        equipped me to deliver scalable solutions. Additionally, I have implemented secure authentication mechanisms and leveraged GitHub for version control in collaborative projects.
    
        Here's how my skills align with your requirements:
    
        * Backend Development: Proficient in Python and Flask for robust application development.
        * Database Management: Skilled in designing and optimizing MongoDB databases.
        * API Integration: Experienced in creating and connecting RESTful APIs effectively.
        * Cloud Deployment: Hands-on experience deploying scalable solutions on AWS.
        * Collaboration Tools: Adept at version control and team collaboration using GitHub.
    
        I am inspired by your organization's commitment to fostering innovation and excellence. Joining your team would not only allow me to contribute meaningfully but also enable me to grow as a developer in a dynamic environment.
    
        I have attached my resume for your review and would be delighted to discuss how my skills align with your team's goals. Thank you for considering my application. I look forward to the opportunity to contribute and learn from your expertise.
    
        Warm regards,
        Ashneet Kaur
        7668431481
      `,
      attachments: [{ name: 'Scanned by Gmail' }],
    }
  },
  {
    sender: "Weekly Escape",
    snippet: "What falling in love does to your body; how one mysterious species is rewriting human history",
    time: "Jan 22",
    priority: "Normal",
    emailData: {
      from: 'Ashneet Kaur',
      fromemail: 'asheetkaur@gmail.com',
      to: 'Halo sr',
      subject: 'Application for Python Developer Intern Position',
      date: 'Dec 20, 2021',
      time: '5:47 PM',
      content: `
        Good Evening,
    
        I hope this email finds you well. My name is Ashneet Kaur, a B.Tech Computer Science and Engineering student, graduating in 2025. I am excited to apply for the Python Developer Intern position at your esteemed organization.
    
        With hands-on experience in Python and Flask, I have built dynamic backend systems, integrated RESTful APIs, and ensured seamless application functionality. My expertise in MongoDB for efficient data management, combined with deploying cloud-ready applications on AWS, has
        equipped me to deliver scalable solutions. Additionally, I have implemented secure authentication mechanisms and leveraged GitHub for version control in collaborative projects.
    
        Here's how my skills align with your requirements:
    
        * Backend Development: Proficient in Python and Flask for robust application development.
        * Database Management: Skilled in designing and optimizing MongoDB databases.
        * API Integration: Experienced in creating and connecting RESTful APIs effectively.
        * Cloud Deployment: Hands-on experience deploying scalable solutions on AWS.
        * Collaboration Tools: Adept at version control and team collaboration using GitHub.
    
        I am inspired by your organization's commitment to fostering innovation and excellence. Joining your team would not only allow me to contribute meaningfully but also enable me to grow as a developer in a dynamic environment.
    
        I have attached my resume for your review and would be delighted to discuss how my skills align with your team's goals. Thank you for considering my application. I look forward to the opportunity to contribute and learn from your expertise.
    
        Warm regards,
        Ashneet Kaur
        7668431481
      `,
      attachments: [{ name: 'Scanned by Gmail' }],
    }
  },
  {
    sender: "Atlassian",
    snippet: "Confluence subscription moved to Free plan",
    time: "Jan 18",
    priority: "Normal",
    emailData: {
      from: 'Ashneet Kaur',
      fromemail: 'asheetkaur@gmail.com',
      to: 'Halo sr',
      subject: 'Application for Python Developer Intern Position',
      date: 'Dec 20, 2021',
      time: '5:47 PM',
      content: `
        Good Evening,
    
        I hope this email finds you well. My name is Ashneet Kaur, a B.Tech Computer Science and Engineering student, graduating in 2025. I am excited to apply for the Python Developer Intern position at your esteemed organization.
    
        With hands-on experience in Python and Flask, I have built dynamic backend systems, integrated RESTful APIs, and ensured seamless application functionality. My expertise in MongoDB for efficient data management, combined with deploying cloud-ready applications on AWS, has
        equipped me to deliver scalable solutions. Additionally, I have implemented secure authentication mechanisms and leveraged GitHub for version control in collaborative projects.
    
        Here's how my skills align with your requirements:
    
        * Backend Development: Proficient in Python and Flask for robust application development.
        * Database Management: Skilled in designing and optimizing MongoDB databases.
        * API Integration: Experienced in creating and connecting RESTful APIs effectively.
        * Cloud Deployment: Hands-on experience deploying scalable solutions on AWS.
        * Collaboration Tools: Adept at version control and team collaboration using GitHub.
    
        I am inspired by your organization's commitment to fostering innovation and excellence. Joining your team would not only allow me to contribute meaningfully but also enable me to grow as a developer in a dynamic environment.
    
        I have attached my resume for your review and would be delighted to discuss how my skills align with your team's goals. Thank you for considering my application. I look forward to the opportunity to contribute and learn from your expertise.
    
        Warm regards,
        Ashneet Kaur
        7668431481
      `,
      attachments: [{ name: 'Scanned by Gmail' }],
    }
  },
  {
    sender: "GitHub",
    snippet: "[Aditya5harma] A security advisory on mongoose affects at least one of your repositories",
    time: "Jan 18",
    priority: "High",
    emailData: {
      from: 'Rohan Sharma',
      fromemail: 'rohan.sharma@gmail.com',
      to: 'HR Manager',
      subject: 'Request for Leave Approval',
      date: 'Jan 15, 2023',
      time: '11:30 AM',
      content: `
        Dear HR Manager,
  
        I hope this email finds you well. I am writing to formally request leave from January 20 to January 25, 2023, due to personal reasons. I have ensured that all my ongoing tasks are up to date and will hand over any pending work to my colleague for seamless continuity.
  
        I kindly request your approval for this leave. Please let me know if you need any additional information.
  
        Thank you for your understanding.
  
        Best regards,
        Rohan Sharma
        9876543210
      `,
      attachments: [{ name: 'Leave Request Form.pdf' }],
    }
  },
  {
    sender: "Up Next from BCG",
    snipper: "A Message from Our CEO",
    time: "Jan 17",
    priority: "Normal",
    emailData: {
      from: 'Priya Verma',
      fromemail: 'priya.verma@yahoo.com',
      to: 'Customer Support',
      subject: 'Inquiry About Order #45678',
      date: 'Mar 10, 2022',
      time: '3:15 PM',
      content: `
        Hi Team,
  
        I am writing to inquire about the status of my order #45678, which was placed on March 5, 2022. The delivery was scheduled for March 9, but I have not yet received any updates on its status.
  
        I would appreciate it if you could look into this matter and provide me with an update at the earliest.
  
        Thank you for your assistance.
  
        Regards,
        Priya Verma
        8754321098
      `,
      attachments: [{ name: 'Order Confirmation.pdf' }],
    }
  },
  {
    sender: "Must reads",
    snippet: "5 must reads for the weekend",
    time: "Jan 17",
    priority: "Normal",
    emailData: {
      from: 'Arjun Mehta',
      fromemail: 'arjun.mehta@hotmail.com',
      to: 'Team Lead',
      subject: 'Weekly Report Submission',
      date: 'Feb 27, 2023',
      time: '9:45 AM',
      content: `
        Hello [Team Lead's Name],
  
        Please find attached the weekly report for the project "Optimizing Search Algorithms." The report highlights the progress, challenges faced, and next steps for the upcoming week.
  
        Let me know if you have any feedback or require additional details.
  
        Best regards,
        Arjun Mehta
        9123456780
      `,
      attachments: [{ name: 'Weekly_Report_Feb27_2023.docx' }],
    }
  },
  {
    sender: "Google Cloud Platform",
    snippet: "[Action required] Your verification is past due. Help Google verify your account",
    time: "Jan 17",
    priority: "High",
    emailData: {
      from: 'Sneha Patel',
      fromemail: 'sneha.patel@gmail.com',
      to: 'Admissions Office',
      subject: 'Follow-up on Application Status',
      date: 'Apr 5, 2023',
      time: '10:20 AM',
      content: `
        Dear Admissions Office,
  
        I hope you are doing well. I am writing to follow up on my application for the Master's program in Data Science, submitted on March 15, 2023. I wanted to inquire if there are any updates regarding the status of my application.
  
        Please let me know if there is any additional information or documents needed from my side.
  
        Thank you for your time and assistance.
  
        Sincerely,
        Sneha Patel
        8192345678
      `,
      attachments: [{ name: 'Application_ID_12345.pdf' }],
    }
  },
];

const analyticsData = {
  snippet: "This email is an application for the Python Developer Intern position. The applicant highlights their experience with Python, Flask, MongoDB, and AWS.",
  priority: "High",
  insights: "The email demonstrates strong alignment with the job requirements and showcases relevant technical skills.",
};

function getSenderNameOrEmail(fromString) {
  // Check if the string contains a sender name
  if (fromString.includes("<")) {
    // Extract the part before `<` (the name)
    return fromString.split("<")[0].trim();
  } else {
    // If no `<`, return the full email
    return fromString.trim();
  }
}
function getDayAndMonth(dateString) {
  // Convert to Date object
  const date = new Date(dateString);
  // Format day and month
  const day = date.getDate(); // Day of the month
  const month = date.toLocaleString("en-IN", { month: "short" }); // Short month name
  return `${day} ${month}`;
}

const convertOutlookToUniformFormat = (outlookEmailList) => {
  return outlookEmailList.map(outlookMail => {
    return ({ ...outlookMail, snippet: outlookMail.bodyPreview, priority: outlookMail.importance })
  })
}

const EmailList = ({ emailList, isOutlook = false }) => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const uniformEmailList = !isOutlook ? [...emailList] : convertOutlookToUniformFormat(emailList);
  // const [isHovered, setIsHovered] = useState(false);
  const [isScaled, setIsScaled] = useState(false);
  const scaledRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (scaledRef.current && !scaledRef.current.contains(event.target)) {
        setIsScaled(false);
      }
    };

    if (isScaled) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isScaled]);


  const closeModal = () => {
    setSelectedEmail(null);
    setIsModalOpen(false);
  };

  const openEmailModal = (email) => () => {
    setSelectedEmail(email);
    setIsModalOpen(true);
  }
  if (!emailList || emailList.length === 0) {
    return null;
  }

  return (
    <div className="pt-0 flex items-center w-full justify-center sm:justify-start gap-2">
      {/* <div className="hidden sm:block h-10 w-10"></div> */}
      {/* Desktop Email Table view*/}
      <div
        onClick={() => setIsScaled(true)}
        className={`hidden sm:block  overflow-x-auto w-full sm:w-full rounded-lg mb-4 border border-gray-200 shadow-md cursor-pointer
        ${isScaled ? "opacity-0" : "opacity-100 "}`}
      >

        {/* <div className="overflow-x-auto w-full overflow-y-auto max-h-[300px] scrollbar-none pointer-events-none"> */}
        <div className="overflow-x-hidden w-full overflow-y-auto max-h-[300px]  no-scrollbar">
          <table className="min-w-full border-collapse bg-white rounded-t-lg divide-y divide-gray-200">
            <thead className="rounded-lg ">
              <tr className='bg-gray-100 rounded-lg'>
                <th scope="col" className="px-2 py-1 text-left text-sm font-medium text-gray-600">
                  Sender
                </th>
                <th scope="col" className="px-2 py-1 text-left text-sm font-medium text-gray-600">
                  Snippet
                </th>
                <th scope="col" className="px-2 py-1 text-left text-sm font-medium text-gray-600">
                  Time
                </th>
                <th scope="col" className="px-2 py-1 text-left text-sm font-medium text-gray-600">
                  Priority
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {uniformEmailList?.map((email, index) => {
                // const display = email.subject ? <><span className='text-gray-800'>{email.subject.slice(0, 70) + " "}</span> {((email?.snippet || "").length <= (69 - email.subject.length)) ? (email?.snippet || "") : (email?.snippet || "").slice(0, 70 - email.subject.length - 1) + "..."}</> : (email?.snippet || "").length <= 70 ? (email?.snippet || "") : (email?.snippet || "").slice(0, 70) + "...";
                const subject = email?.subject || "";
                const snippet = email?.snippet || "";

                let display1 = "";

                if (subject) {
                  const remainingLength = 70 - subject.length - 1; // -1 for the space between subject and snippet
                  display1 = subject.length >= 70
                    ? <span className='text-gray-800'> {subject.slice(0, 70)} </span>
                    : <><span className='text-gray-800'> {subject.slice(0, 70)} </span>{(" " + snippet.length <= remainingLength ? snippet : snippet.slice(0, remainingLength) + "...")} </>;
                } else {
                  display1 = snippet.length <= 70 ? snippet : snippet.slice(0, 67) + "...";
                }
                return (
                  <tr
                    key={index}
                    className=" hover:bg-gray-50 cursor-pointer"
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                    onClick={openEmailModal(email)}
                  >
                    {/* <td className="px-2 py-1 text-sm font-medium text-gray-900 whitespace-nowrap"> */}
                    <td className="px-2 py-1 text-sm font-medium text-gray-900 ">
                      <div className="flex items-center">
                        <FiMail className="mr-1 text-[#5652CF]" size={14} />
                        {isOutlook ? email.from?.name : getSenderNameOrEmail(email.from)}
                      </div>
                    </td>
                    <td className="px-2 py-1 text-sm font-semibold text-gray-500 whitespace-nowrap">
                      {display1}
                      {/* {((email.subject || "") + (email?.snippet || "")).length > 70 ? <><span>{(email.subject || "").slice(email.subject?.length || 0, 70)}</span> {(email?.snippet || "").slice(0, 70) + "..." }</>: <><span>{(email.subject || "").slice(email.subject?.length || 0, 70)}</span> {(email?.snippet || "").slice(0, 70) } </>} */}
                    </td>
                    <td className="px-2 py-1 text-sm text-gray-500 whitespace-nowrap">
                      {hoveredRow === index ? (
                        <div className="flex font-semibold items-center space-x-1">
                          <FiArchive className="text-gray-700 hover:text-gray-700" size={14} />
                          <FiTrash2 className="text-gray-700 hover:text-gray-700" size={14} />
                          <FiArrowRightCircle className="text-gray-700 hover:text-gray-700" size={14} />
                        </div>
                      ) : (
                        <div className="flex items-center">
                          <FiClock className="mr-1 text-gray-400" size={14} />
                          {getDayAndMonth(email.date)}
                        </div>
                      )}
                    </td>
                    <td className="whitespace-nowrap px-2 py-1 text-sm font-medium">
                      <span
                        className={`px-1 py-0.5 rounded-lg text-sm font-semibold flex items-center ${email.priority === "Critical"
                          ? "bg-red-100 text-red-600"
                          : email.priority === "High"
                            ? "bg-orange-100 text-orange-600"
                            : email.priority === "Medium"
                              ? "bg-yellow-100 text-yellow-600"
                              : email.priority === "Low"
                                ? "bg-green-100 text-green-600"
                                : "bg-gray-100 text-gray-600"
                          }`}
                      >
                        {email.priority === "Critical" && <FiAlertCircle className="mr-1 text-red-600" size={12} />}
                        {email.priority === "High" && <FiAlertTriangle className="mr-1 text-orange-600" size={12} />}
                        {email.priority === "Medium" && <FiFlag className="mr-1 text-yellow-600" size={12} />}
                        {email.priority === "Low" && <FiCheckCircle className="mr-1 text-green-600" size={12} />}
                        {email.priority || "Normal"}
                      </span>
                    </td>
                  </tr>
                )
              }
              )}
            </tbody>

          </table>
        </div>
      </div>


      {/* Mobile Email Card View */}
      <div
        className={`block sm:hidden  p-2 overflow-x-auto w-full sm:w-[88%] rounded-lg mb-4 border border-zinc-200 bg-zinc-700 shadow-md cursor-pointer`}
      >
        <div className="w-full max-h-[60vh] overflow-y-auto space-y-2  scrollbar-none">
          {uniformEmailList?.map((email, index) => {
            const subject = email?.subject || "";
            const snippet = email?.snippet || "";
            const displayText = subject
              ? `${subject} ${snippet.slice(0, Math.max(0, 70 - subject.length - 1))}...`
              : snippet.slice(0, 70) + "...";

            return (
              <div
                key={index}
                onClick={openEmailModal(email)}
                className={`p-3 bg-white shadow-sm rounded-lg border border-gray-200 cursor-pointer ${!email.isRead ? "font-bold" : ""
                  }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <FiMail className="text-[#5652CF]" />
                    <span className="text-gray-900 text-sm font-medium">
                      {isOutlook ? email.from?.name : getSenderNameOrEmail(email.from)}
                    </span>
                  </div>
                  <div className="flex items-center text-xs text-gray-500">
                    <FiClock className="mr-1" size={12} />
                    {getDayAndMonth(email.date)}
                  </div>
                </div>

                <div className="mt-2 flex justify-between gap-2">
                  <div className=" text-gray-600 text-sm whitespace-nowrap overflow-hidden text-ellipsis">
                    {displayText}
                  </div>
                  <span
                    className={`px-2 py-0.5 rounded-lg text-xs font-semibold flex items-center ${email.priority === "Critical"
                      ? "bg-red-100 text-red-600"
                      : email.priority === "High"
                        ? "bg-orange-100 text-orange-600"
                        : email.priority === "Medium"
                          ? "bg-yellow-100 text-yellow-600"
                          : email.priority === "Low"
                            ? "bg-green-100 text-green-600"
                            : "bg-gray-100 text-gray-600"
                      }`}
                  >
                    {email.priority === "Critical" && <FiAlertCircle className="mr-1" size={12} />}
                    {email.priority === "High" && <FiAlertTriangle className="mr-1" size={12} />}
                    {email.priority === "Medium" && <FiFlag className="mr-1" size={12} />}
                    {email.priority === "Low" && <FiCheckCircle className="mr-1" size={12} />}
                    {email.priority || "Normal"}
                  </span>
                </div>
              </div>
            );
          })}
        </div>


      </div>

      {isScaled && (
        <div
          className="fixed inset-0 max-sm:p-3 sm:mr-10 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm z-50 transition-all duration-600 ease-in-out transform "

        >
          <div
            // onMouseEnter={() => setIsHovered(true)}
            // onMouseLeave={() => setIsHovered(false)}
            ref={scaledRef}
            className="max-h-[600px] items-center overflow-hidden bg-white rounded-xl justify-center w-full sm:w-[60%] "
          >
            <div className="overflow-x-auto w-full overflow-y-auto max-h-[600px] scrollbar-none">
              <table className="min-w-full border-collapse bg-white rounded-t-lg divide-y divide-gray-200">
                <thead className="rounded-lg ">
                  <tr className='bg-gray-100 rounded-lg'>
                    <th scope="col" className="px-3 py-2 text-left text-sm font-medium text-gray-600">
                      Sender
                    </th>
                    <th scope="col" className="px-3 py-2 text-left text-sm font-medium text-gray-600">
                      Snippet
                    </th>
                    <th scope="col" className="px-3 py-2 text-left text-sm font-medium text-gray-600">
                      Time
                    </th>
                    <th scope="col" className="px-3 py-2 text-left text-sm font-medium text-gray-600">
                      Priority
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {uniformEmailList?.map((email, index) => {
                    // const display = email.subject ? <><span className='text-gray-800'>{email.subject.slice(0, 70) + " "}</span> {((email?.snippet || "").length <= (69 - email.subject.length)) ? (email?.snippet || "") : (email?.snippet || "").slice(0, 70 - email.subject.length - 1) + "..."}</> : (email?.snippet || "").length <= 70 ? (email?.snippet || "") : (email?.snippet || "").slice(0, 70) + "...";
                    const subject = email?.subject || "";
                    const snippet = email?.snippet || "";

                    let display1 = "";

                    if (subject) {
                      const remainingLength = 70 - subject.length - 1; // -1 for the space between subject and snippet
                      display1 = subject.length >= 70
                        ? <span className='text-gray-800'> {subject.slice(0, 70)} </span>
                        : <><span className='text-gray-800'> {subject.slice(0, 70)} </span>{(" " + snippet.length <= remainingLength ? snippet : snippet.slice(0, remainingLength) + "...")} </>;
                    } else {
                      display1 = snippet.length <= 70 ? snippet : snippet.slice(0, 67) + "...";
                    }
                    return (
                      <tr
                        key={index}
                        className={`hover:bg-gray-50 cursor-pointer ${!email.isRead ? "font-bold" : ""} `}
                        onMouseEnter={() => setHoveredRow(index)}
                        onMouseLeave={() => setHoveredRow(null)}
                        onClick={openEmailModal(email)}
                      >
                        <td className="px-3 py-2 text-sm font-medium text-gray-900 whitespace-nowrap">
                          <div className="flex items-center">
                            <FiMail className="mr-2 text-[#5652CF]" />
                            {isOutlook ? email.from?.name : getSenderNameOrEmail(email.from)}
                          </div>
                        </td>
                        <td className="px-3 py-2 text-sm font-semibold text-gray-500 whitespace-nowrap">
                          {display1}
                          {/* {((email.subject || "") + (email?.snippet || "")).length > 70 ? <><span>{(email.subject || "").slice(email.subject?.length || 0, 70)}</span> {(email?.snippet || "").slice(0, 70) + "..." }</>: <><span>{(email.subject || "").slice(email.subject?.length || 0, 70)}</span> {(email?.snippet || "").slice(0, 70) } </>} */}
                        </td>
                        <td className="px-3 py-2 text-sm text-gray-500 whitespace-nowrap">
                          {hoveredRow === index ? (
                            <div className="flex font-semibold items-center space-x-2">
                              <FiArchive className="text-gray-700 hover:text-gray-700" size={15} />
                              <FiTrash2 className="text-gray-700 hover:text-gray-700" size={15} />
                              <FiArrowRightCircle className="text-gray-700 hover:text-gray-700" size={15} />
                            </div>
                          ) : (
                            <div className="flex items-center">
                              <FiClock className="mr-2 text-gray-400" />
                              {getDayAndMonth(email.date)}
                            </div>
                          )}
                        </td>
                        <td className="whitespace-nowrap px-3 py-2 text-sm font-medium">
                          <span
                            className={`px-2 py-1 rounded-xl text-xs font-semibold flex items-center ${email.priority === "Critical"
                              ? "bg-red-100 text-red-600"
                              : email.priority === "High"
                                ? "bg-orange-100 text-orange-600"
                                : email.priority === "Medium"
                                  ? "bg-yellow-100 text-yellow-600"
                                  : email.priority === "Low"
                                    ? "bg-green-100 text-green-600"
                                    : "bg-gray-100 text-gray-600"
                              }`}
                          >
                            {email.priority === "Critical" && <FiAlertCircle className="mr-2 text-red-600" />}
                            {email.priority === "High" && <FiAlertTriangle className="mr-2 text-orange-600" />}
                            {email.priority === "Medium" && <FiFlag className="mr-2 text-yellow-600" />}
                            {email.priority === "Low" && <FiCheckCircle className="mr-2 text-green-600" />}
                            {email.priority || "Normal"}
                          </span>
                        </td>
                      </tr>
                    )
                  }
                  )}
                </tbody>

              </table>
            </div>


          </div>
        </div>
      )}

      {isModalOpen && (
        <EmailComponent isOutlook={isOutlook} messageId={selectedEmail.id} analytics={analyticsData} onClose={closeModal} />
      )}
    </div>
  );
};


export default EmailList;